export default {
  findItemNum: function (array, id) {
    for (var i = 0; i < array.length; i++) {
      if (array[i].val.id === id) return i
    }
    return null
  },

  // array.sort(function (one, two) { return one.val.chainIndx > two.val.chainIndx }) ������-�� �� ��������. �������� �� 95%, �� ��������� �������� ����������������� �� ��� ���� - ����!!!
  // ������� ������ ���������� ��� bubbleSort
  sort: function (arr, compareFn) {
    var len = arr.length
    for (var i = len - 1; i >= 0; i--) {
      for (var j = 1; j <= i; j++) {
        // console.log(arr[j].val.chainIndx)
        if (compareFn(arr[j - 1], arr[j])) {
          var temp = arr[j - 1]
          arr[j - 1] = arr[j]
          arr[j] = temp
        }
      }
    }
    return arr
  }
}



// WEBPACK FOOTER //
// ./src/technical/arrayTools/arrayTools.js